import React, { useState, useEffect } from "react";
import { Steps, Button, Col, Row, Spin, Card, Typography, Flex } from "antd";
import { connect, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useForm } from "antd/lib/form/Form";
import "./addLoanProduct.css";
import DetailsForm from "../components/DetailsForm";
import CurrencyForm from "../components/CurrencyForm";
import TermsForm from "../components/TermsForm";
import SettingsForm from "../components/SettingsForm";
import ChargesForm from "../components/ChargesForm";
import AccountingForm from "../components/AccountingForm";
import Preview from "../components/Preview";
import appLabel from "../../../../config/appLabel";
import cnt from "../../../../services/definedConstant";
import { BOM } from "../../../../services/definedMethod";
import definedApi from "../../../../services/definedApi";
import styles from "../../../../assets/styles/styles";

const { Text } = Typography;

const LoanProductForm = (props) => {
  const { userData } = props;
  const { session } = userData;

  const navigate = useNavigate();
  const [form] = useForm();

  const [fundsData, setFundsData] = useState([]);
  const [currencyData, setCurrencyData] = useState([]);
  const [amortizationData, setAmortizationData] = useState([]);
  const [interestTypeData, setInterestTypeData] = useState([]);
  const [
    interestCalculationPeriodTypeData,
    setInterestCalculationPeriodTypeData,
  ] = useState([]);
  const [daysInYearData, setDaysInYearData] = useState([]);
  const [daysInMonthData, setDaysInMonthData] = useState([]);
  const [
    preClosureInterestCalculationStrategy,
    setPreClosureInterestCalculationStrategy,
  ] = useState([]);
  const [rescheduleStrategyType, setRescheduleStrategyType] = useState([]);
  const [
    interestRecalculationCompoundingType,
    setInterestRecalculationCompoundingType,
  ] = useState([]);
  const [recalculationRestFrequencyType, setRecalculationRestFrequencyType] =
    useState([]);
  const [
    transactionProcessingStrategyOptions,
    setTransactionProcessingStrategyOptions,
  ] = useState([]);
  const [charges, setCharges] = useState([]);
  const [penaltyOptions, setPenaltyOptions] = useState([]);
  const [
    interestRecalculationFrequencyTypeOptions,
    setinterestRecalculationFrequencyTypeOptions,
  ] = useState([]);
  const [
    interestRecalculationDayOfWeekTypeOptions,
    setInterestRecalculationDayOfWeekTypeOptions,
  ] = useState([]);
  const [
    interestRecalculationNthDayTypeOptions,
    setInterestRecalculationNthDayTypeOptions,
  ] = useState([]);
  const [floatingRateOptions, setFloatingRateOptions] = useState([]);

  const [assetAccountOptions, setAssetAccountOptions] = useState([]);
  const [incomeAccountOptions, setIncomeAccountOptions] = useState([]);
  const [expenseAccountOptions, setExpenseAccountOptions] = useState([]);
  const [liabilityAccountOptions, setLiabilityAccountOptions] = useState([]);
  const [paymentTypeOptions, setPaymentTypeOptions] = useState([]);
  const [repaymentFrequencyTypeOptions, setRepaymentFrequencyTypeOptions] =
    useState([]);
  const [
    interestRateFrequencyTypeOptions,
    setInterestRateFrequencyTypeOptions,
  ] = useState([]);
  const [accountingRuleOptions, setAccountingRuleOptions] = useState([]);
  const [valueConditionTypeOptions, setValueConditionTypeOptions] = useState(
    []
  );
  const [chargesOptions, setChargeOptions] = useState([]);
  const [chargeBasedOnCurrencyList, setChargeBasedOnCurrencyList] = useState(
    []
  );
  const [penaltyBasedOnCurrencyList, setPenaltyBasedOnCurrencyList] = useState(
    []
  );

  const [interestRateByLoanCycleSource, setInterestRateByLoanCycleSource] =
    useState([]);
  const [repaymentsByLoanCycleSource, setRepaymentsByLoanCycleSource] =
    useState([]);
  const [principalByLoanCycleSource, setPrincipalByLoanCycleSource] = useState(
    []
  );
  const [chargeTableSource, setChargeTableSource] = useState([]);
  const [penaltyTableSource, setPenaltyTableSource] = useState([]);
  const [configureFundTableSource, setConfigureFundTableSource] = useState([]);
  const [mapFeeTableSource, setMapFeeTableSource] = useState([]);
  const [mapPenaltyTableSource, setMapPenaltyTableSource] = useState([]);
  const [loanProductDetails, setLoanProductDetails] = useState([]);

  const [radioChecked, setRadioChecked] = useState(2);

  const [current, setCurrent] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [variableInstallmentsChecked, setVariableInstallmentsChecked] =
    useState(false);
  const [recalculateInterestCheck, setRecalculateInterestCheck] =
    useState(false);
  const [multipleDisbursalsCheck, setMultipleDisbursalsCheck] = useState(false);
  const [guaranteeRequirementsCheck, setGuaranteeRequirementsCheck] =
    useState(false);
  const [includeInBorrowerCycle, setIncludeInBorrowerCycle] = useState(false);
  const [useBorrowerCycle, setUseBorrowerCycle] = useState(false);
  const [isLinkedToFloatingInterestRates, setIsLinkedToFloatingInterestRates] =
    useState(false);
  const [isEqualAmortization, setIsEqualAmortization] = useState(false);
  const [
    allowPartialPeriodInterestCalcualtion,
    setAllowPartialPeriodInterestCalcualtion,
  ] = useState(false);
  const [canDefineInstallmentAmount, setCanDefineInstallmentAmount] =
    useState(false);
  const [
    accountMovesOutOfNPAOnlyOnArrearsCompletion,
    setAccountMovesOutOfNPAOnlyOnArrearsCompletion,
  ] = useState(false);
  const [allowVariableInstallments, setAllowVariableInstallments] =
    useState(false);
  const [canUseForTopup, setCanUseForTopup] = useState(false);
  const [isInterestRecalculationEnabled, setIsInterestRecalculationEnabled] =
    useState(false);
  const [holdGuaranteeFunds, setHoldGuaranteeFunds] = useState(false);
  const [multiDisburseLoan, setMultiDisburseLoan] = useState(false);
  const [
    isArrearsBasedOnOriginalSchedule,
    setIsArrearsBasedOnOriginalSchedule,
  ] = useState(false);
  const [allowAttributeConfiguration, setAllowAttributeConfiguration] =
    useState(false);
  const [amortization, setAmortization] = useState(true);
  const [transactionProcessingStrategy, setTransactionProcessingStrategy] =
    useState(true);
  const [arrearsTolerance, setArrearsTolerance] = useState(true);
  const [graceOnPrincipalAndInterest, setGraceOnPrincipalAndInterest] =
    useState(true);
  const [interestMethod, setInterestMethod] = useState(true);
  const [interestCalcPeriod, setInterestCalcPeriod] = useState(true);
  const [repaymentFrequency, setRepaymentFrequency] = useState(true);
  const [graceOnArrearsAging, setGraceOnArrearsAging] = useState(true);

  const [formData, setFormData] = useState({
    details: null,
    currency: null,
    terms: null,
    settings: null,
    charges: null,
    accounting: null,
  });

  useEffect(() => {
    getTemplate();
    setTimeout(() => {
      setIsLoading(false);
    }, 1000);
  }, []);

  function getTemplate() {
    let body = {
      session,
    };

    BOM.FetchReqAction(body, definedApi.LoanProductTemplate, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err);
      } else {
        const objList = res;
        setLoanProductDetails(objList);

        let tempFunds = [];
        let tempCurrency = [];
        let tempAmortization = [];
        let tempInterestType = [];
        let tempInterestCalculationPeriodType = [];
        let tempDaysInYearType = [];
        let tempDaysInMonthType = [];
        let tempPreClosureInterestCalculationStrategy = [];
        let tempRescheduleStrategyType = [];
        let tempInterestRecalculationCompoundingType = [];
        let tempRecalculationRestFrequencyType = [];
        let tempTransactionProcessingStrategy = [];
        let tempCharges = [];
        let tempAccountingRuleOptions = [];
        let tempAssetAccountOptions = [];
        let tempIncomeAccountOptions = [];
        let tempExpenseAccountOptions = [];
        let tempLiabilityAccountOptions = [];
        let tempPaymentTypeOptions = [];
        let tempRepaymentFrequencyTypeOptions = [];
        let tempInterestRateFrequencyTypeOptions = [];
        let tempValueConditionTypeOptions = [];
        let tempChargesOptions = [];
        let tempPenaltyOptions = [];
        let tempinterestRecalculationFrequencyTypeOptions = [];
        let tempInterestRecalculationDayOfWeekTypeOptions = [];
        let tempInterestRecalculationNthDayTypeOptions = [];
        let tempFloatingRateOptions = [];

        objList?.fundOptions?.forEach((element) => {
          tempFunds.push({
            value: element.id,
            label: element.name,
          });
        });

        objList?.currencyOptions?.forEach((element) => {
          tempCurrency.push({
            value: element.code,
            label: element.displayLabel,
          });
        });

        objList?.amortizationTypeOptions?.forEach((element) => {
          tempAmortization.push({
            value: element.id,
            label: element.value,
          });
        });

        objList?.floatingRateOptions?.forEach((element) => {
          tempFloatingRateOptions.push({
            value: element.id,
            label: element.name,
          });
        });

        objList?.interestTypeOptions?.forEach((element) => {
          tempInterestType.push({
            value: element.id,
            label: element.value,
          });
        });

        objList?.interestCalculationPeriodTypeOptions?.forEach((element) => {
          tempInterestCalculationPeriodType.push({
            value: element.id,
            label: element.value,
          });
        });

        objList?.daysInYearTypeOptions?.forEach((element) => {
          tempDaysInYearType.push({
            value: element.id,
            label: element.value,
          });
        });

        objList?.daysInMonthTypeOptions?.forEach((element) => {
          tempDaysInMonthType.push({
            value: element.id,
            label: element.value,
          });
        });

        objList?.preClosureInterestCalculationStrategyOptions?.forEach(
          (element) => {
            tempPreClosureInterestCalculationStrategy.push({
              value: element.id,
              label: element.value,
            });
          }
        );

        objList?.rescheduleStrategyTypeOptions?.forEach((element) => {
          tempRescheduleStrategyType.push({
            value: element.id,
            label: element.value,
          });
        });

        objList?.interestRecalculationCompoundingTypeOptions?.forEach(
          (element) => {
            tempInterestRecalculationCompoundingType.push({
              value: element.id,
              label: element.value,
            });
          }
        );

        objList?.interestRecalculationFrequencyTypeOptions?.forEach(
          (element) => {
            tempRecalculationRestFrequencyType.push({
              value: element.id,
              label: element.value,
            });
          }
        );

        objList?.transactionProcessingStrategyOptions?.forEach((element) => {
          tempTransactionProcessingStrategy.push({
            value: element.id,
            label: element.name,
          });
        });

        objList?.chargeOptions?.forEach((element) => {
          tempCharges.push({
            value: element.id,
            label: element.name,
          });
        });

        objList?.penaltyOptions?.forEach((element) => {
          tempPenaltyOptions.push({
            value: element.id,
            label: element.name,
            currencyName: element?.currency?.name,
            currencyCode: element?.currency?.code,
          });
        });

        objList?.accountingRuleOptions?.forEach((element) => {
          tempAccountingRuleOptions.push({
            value: element.id,
            label: element.value,
          });
        });

        objList?.accountingMappingOptions?.assetAccountOptions?.forEach(
          (element) => {
            tempAssetAccountOptions.push({
              value: element.id,
              label: `${element.glCode} (${element.name})`,
            });
          }
        );

        objList?.accountingMappingOptions?.incomeAccountOptions?.forEach(
          (element) => {
            tempIncomeAccountOptions.push({
              value: element.id,
              label: `${element.glCode} (${element.name})`,
            });
          }
        );

        objList?.accountingMappingOptions?.expenseAccountOptions?.forEach(
          (element) => {
            tempExpenseAccountOptions.push({
              value: element.id,
              label: `${element.glCode} (${element.name})`,
            });
          }
        );

        objList?.accountingMappingOptions?.liabilityAccountOptions?.forEach(
          (element) => {
            tempLiabilityAccountOptions.push({
              value: element.id,
              label: `${element.glCode} (${element.name})`,
            });
          }
        );

        objList?.paymentTypeOptions?.forEach((element) => {
          tempPaymentTypeOptions.push({
            value: element.id,
            label: element.name,
          });
        });

        objList?.repaymentFrequencyTypeOptions?.forEach((element) => {
          tempRepaymentFrequencyTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });

        objList?.interestRateFrequencyTypeOptions?.forEach((element) => {
          tempInterestRateFrequencyTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });

        objList?.valueConditionTypeOptions?.forEach((element) => {
          tempValueConditionTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });

        objList?.chargeOptions?.forEach((element) => {
          tempChargesOptions.push({
            value: element.id,
            label: `${element.name}(${element?.currency?.name})`,
            currencyName: element?.currency?.name,
            currencyCode: element?.currency?.code,
          });
        });

        objList?.interestRecalculationFrequencyTypeOptions?.forEach(
          (element) => {
            tempinterestRecalculationFrequencyTypeOptions.push({
              value: element.id,
              label: element.value,
            });
          }
        );

        objList?.interestRecalculationDayOfWeekTypeOptions?.forEach(
          (element) => {
            tempInterestRecalculationDayOfWeekTypeOptions.push({
              value: element.id,
              label: element.value,
            });
          }
        );

        objList?.interestRecalculationNthDayTypeOptions?.forEach((element) => {
          tempInterestRecalculationNthDayTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });

        setFundsData(tempFunds);
        setCurrencyData(tempCurrency);
        setAmortizationData(tempAmortization);
        setInterestTypeData(tempInterestType);
        setInterestCalculationPeriodTypeData(tempInterestCalculationPeriodType);
        setDaysInYearData(tempDaysInYearType);
        setDaysInMonthData(tempDaysInMonthType);
        setPreClosureInterestCalculationStrategy(
          tempPreClosureInterestCalculationStrategy
        );
        setRescheduleStrategyType(tempRescheduleStrategyType);
        setInterestRecalculationCompoundingType(
          tempInterestRecalculationCompoundingType
        );
        setRecalculationRestFrequencyType(tempRecalculationRestFrequencyType);
        setTransactionProcessingStrategyOptions(
          tempTransactionProcessingStrategy
        );
        setCharges(tempCharges);
        setAccountingRuleOptions(tempAccountingRuleOptions);
        setAssetAccountOptions(tempAssetAccountOptions);
        setIncomeAccountOptions(tempIncomeAccountOptions);
        setExpenseAccountOptions(tempExpenseAccountOptions);
        setLiabilityAccountOptions(tempLiabilityAccountOptions);
        setPaymentTypeOptions(tempPaymentTypeOptions);
        setRepaymentFrequencyTypeOptions(tempRepaymentFrequencyTypeOptions);
        setInterestRateFrequencyTypeOptions(
          tempInterestRateFrequencyTypeOptions
        );
        setValueConditionTypeOptions(tempValueConditionTypeOptions);
        setChargeOptions(tempChargesOptions);
        setPenaltyOptions(tempPenaltyOptions);
        setinterestRecalculationFrequencyTypeOptions(
          tempinterestRecalculationFrequencyTypeOptions
        );
        setInterestRecalculationDayOfWeekTypeOptions(
          tempInterestRecalculationDayOfWeekTypeOptions
        );
        setInterestRecalculationNthDayTypeOptions(
          tempInterestRecalculationNthDayTypeOptions
        );
        setFloatingRateOptions(tempFloatingRateOptions);
      }
    });
  }

  const onChangeCurrency = (currencyParam) => {
    const chargeForTableData = chargesOptions.filter(
      (item) => item.currencyCode === currencyParam
    );
    form.setFieldsValue({
      chargeId: "",
    });
    setChargeBasedOnCurrencyList([...chargeForTableData]);

    const penaltyForTableData = penaltyOptions.filter(
      (item) => item.currencyCode === currencyParam
    );
    form.setFieldsValue({
      chargeId: "",
    });
    setPenaltyBasedOnCurrencyList([...penaltyForTableData]);
  };

  const handleIncludeInBorrowerCycle = (param) => {
    switch (param) {
      case true:
        setIncludeInBorrowerCycle(true);
        break;
      case false:
        setIncludeInBorrowerCycle(false);
        break;

      default:
        break;
    }
  };

  const handleUseBorrowerCycle = (param) => {
    switch (param) {
      case true:
        setUseBorrowerCycle(true);
        break;
      case false:
        setUseBorrowerCycle(false);
        break;

      default:
        break;
    }
  };

  const handleIsLinkedToFloatingInterestRates = (param) => {
    switch (param) {
      case true:
        setIsLinkedToFloatingInterestRates(true);
        break;
      case false:
        setIsLinkedToFloatingInterestRates(false);
        break;

      default:
        break;
    }
  };

  const handleIsEqualAmortization = (param) => {
    switch (param) {
      case true:
        setIsEqualAmortization(true);
        break;
      case false:
        setIsEqualAmortization(false);
        break;

      default:
        break;
    }
  };

  const handleAllowPartialPeriodInterestCalcualtion = (e) => {
    setAllowPartialPeriodInterestCalcualtion(e.target.checked);
  };

  const handleCanDefineInstallmentAmount = (param) => {
    switch (param) {
      case true:
        setCanDefineInstallmentAmount(true);
        break;
      case false:
        setCanDefineInstallmentAmount(false);
        break;

      default:
        break;
    }
  };

  const handleAccountMovesOutOfNPAOnlyOnArrearsCompletion = (param) => {
    switch (param) {
      case true:
        setAccountMovesOutOfNPAOnlyOnArrearsCompletion(true);
        break;
      case false:
        setAccountMovesOutOfNPAOnlyOnArrearsCompletion(false);
        break;

      default:
        break;
    }
  };

  const handleAllowVariableInstallments = (param) => {
    switch (param) {
      case true:
        setVariableInstallmentsChecked(true);
        break;
      case false:
        setVariableInstallmentsChecked(false);
        break;

      default:
        break;
    }
  };

  const handleCanUseForTopup = (param) => {
    switch (param) {
      case true:
        setCanUseForTopup(true);
        break;
      case false:
        setCanUseForTopup(false);
        break;

      default:
        break;
    }
  };

  const handleIsInterestRecalculationEnabled = (param) => {
    switch (param) {
      case true:
        setRecalculateInterestCheck(true);
        break;
      case false:
        setRecalculateInterestCheck(false);
        break;

      default:
        break;
    }
  };
  const handleHoldGuaranteeFunds = (param) => {
    switch (param) {
      case true:
        setGuaranteeRequirementsCheck(true);
        break;
      case false:
        setGuaranteeRequirementsCheck(false);
        break;

      default:
        break;
    }
  };

  const handleMultiDisburseLoan = (param) => {
    switch (param) {
      case true:
        setMultipleDisbursalsCheck(true);
        break;
      case false:
        setMultipleDisbursalsCheck(false);
        break;

      default:
        break;
    }
  };

  const handleIsArrearsBasedOnOriginalSchedule = (param) => {
    switch (param) {
      case true:
        setIsArrearsBasedOnOriginalSchedule(true);
        break;
      case false:
        setIsArrearsBasedOnOriginalSchedule(false);
        break;

      default:
        break;
    }
  };

  const handleAllowAttributeConfiguration = (param) => {
    switch (param) {
      case true:
        setAllowAttributeConfiguration(true);
        break;
      case false:
        setAllowAttributeConfiguration(false);
        break;

      default:
        break;
    }
  };

  const handleGraceOnArrearsAging = (param) => {
    switch (param) {
      case true:
        setGraceOnArrearsAging(true);
        break;
      case false:
        setGraceOnArrearsAging(false);
        break;

      default:
        break;
    }
  };

  const handleInterestCalcPeriod = (param) => {
    switch (param) {
      case true:
        setInterestCalcPeriod(true);
        break;
      case false:
        setInterestCalcPeriod(false);
        break;

      default:
        break;
    }
  };

  const handleRepaymentFrequency = (param) => {
    switch (param) {
      case true:
        setRepaymentFrequency(true);
        break;
      case false:
        setRepaymentFrequency(false);
        break;

      default:
        break;
    }
  };

  const handleGraceOnPrincipalAndInterest = (param) => {
    switch (param) {
      case true:
        setGraceOnPrincipalAndInterest(true);
        break;
      case false:
        setGraceOnPrincipalAndInterest(false);
        break;

      default:
        break;
    }
  };

  const handleInterestMethod = (param) => {
    switch (param) {
      case true:
        setInterestMethod(true);
        break;
      case false:
        setInterestMethod(false);
        break;

      default:
        break;
    }
  };

  const handleTransactionProcessingStrategy = (param) => {
    switch (param) {
      case true:
        setTransactionProcessingStrategy(true);
        break;
      case false:
        setTransactionProcessingStrategy(false);
        break;

      default:
        break;
    }
  };

  const handleArrearsTolerance = (param) => {
    switch (param) {
      case true:
        setArrearsTolerance(true);
        break;
      case false:
        setArrearsTolerance(false);
        break;

      default:
        break;
    }
  };

  const handleAmortization = (param) => {
    switch (param) {
      case true:
        setAmortization(true);
        break;
      case false:
        setAmortization(false);
        break;

      default:
        break;
    }
  };

  const onChange = (value) => {
    setCurrent(value);
  };

  const onFinishDetailsForm = (values) => {
    setFormData({ ...formData, details: values });
    values.startDate = values.startDate
      ? BOM.DateTime(values.startDate, "only-date")
      : values.startDate;
    values.closeDate = values.closeDate
      ? BOM.DateTime(values.closeDate, "only-date")
      : values.closeDate;
    // values.includeInBorrowerCycle = includeInBorrowerCycle
    setCurrent(current + 1);
  };

  const onFinishCurrencyForm = (values) => {
    setFormData({ ...formData, currency: values });
    setCurrent(current + 1);
  };

  const onFinishTermsForm = (values) => {
    setFormData({ ...formData, terms: values });
    values.useBorrowerCycle = useBorrowerCycle;
    values.isLinkedToFloatingInterestRates = isLinkedToFloatingInterestRates;
    setCurrent(current + 1);

    let principalByLoanCycleSourceArray = [];
    let numberOfRepaymentVariationsForBorrowerCycleArray = [];
    let interestRateVariationsForBorrowerCycleArray = [];

    principalByLoanCycleSource.forEach((element, index) => {
      principalByLoanCycleSourceArray.push({
        borrowerCycleNumber: element.PrincipalPerCycle,
        defaultValue: element.principalCycleNumber,
        maxValue: element.maxPrincipalPerCycle,
        minValue: element.minPrincipalPerCycle,
        valueConditionType: element.principalValueUsageConditionId,
      });
    });

    repaymentsByLoanCycleSource.forEach((element, index) => {
      numberOfRepaymentVariationsForBorrowerCycleArray.push({
        borrowerCycleNumber: element.repaymentPerCycle,
        defaultValue: element.repaymentCycleNumber,
        maxValue: element.maxRepaymentPerCycle,
        minValue: element.minRepaymentPerCycle,
        valueConditionType: element.repaymentValueUsageConditionId,
      });
    });

    interestRateByLoanCycleSource.forEach((element, index) => {
      interestRateVariationsForBorrowerCycleArray.push({
        borrowerCycleNumber: element.interestPerCycle,
        defaultValue: element.interestCycleNumber,
        maxValue: element.interestPerCycle,
        minValue: element.interestPerCycle,
        valueConditionType: element.interestValueUsageConditionId,
      });
    });

    values.principalVariationsForBorrowerCycle =
      principalByLoanCycleSourceArray;
    values.numberOfRepaymentVariationsForBorrowerCycle =
      numberOfRepaymentVariationsForBorrowerCycleArray;
    values.interestRateVariationsForBorrowerCycle =
      interestRateVariationsForBorrowerCycleArray;

    setFormData({
      ...formData,
      terms: values,
      principalVariationsForBorrowerCycle:
        values.principalVariationsForBorrowerCycle,
      numberOfRepaymentVariationsForBorrowerCycle:
        values.numberOfRepaymentVariationsForBorrowerCycle,
      interestRateVariationsForBorrowerCycle:
        values.interestRateVariationsForBorrowerCycle,
    });
  };

  const onFinishSettingsForm = (values) => {
    setFormData({ ...formData, settings: values });
    values.isEqualAmortization = isEqualAmortization;
    values.allowPartialPeriodInterestCalcualtion =
      allowPartialPeriodInterestCalcualtion;
    values.canDefineInstallmentAmount = canDefineInstallmentAmount;
    values.accountMovesOutOfNPAOnlyOnArrearsCompletion =
      accountMovesOutOfNPAOnlyOnArrearsCompletion;
    values.allowVariableInstallments = allowVariableInstallments;
    values.canUseForTopup = canUseForTopup;
    values.isInterestRecalculationEnabled = isInterestRecalculationEnabled;
    values.isArrearsBasedOnOriginalSchedule = isArrearsBasedOnOriginalSchedule;
    values.holdGuaranteeFunds = holdGuaranteeFunds;
    values.multiDisburseLoan = multiDisburseLoan;
    setCurrent(current + 1);
  };

  const onFinishChargesForm = (values) => {
    let tempChargeArray = [];
    chargeTableSource.forEach((element, index) => {
      tempChargeArray.push({
        id: element.id,
        // amount: element.amountToUse,
      });
    });

    values.charges = tempChargeArray;

    delete values.chargeId;

    setFormData({
      ...formData,
      charges: values.charges,
    });
    setCurrent(current + 1);
  };

  const onFinishAccountingForm = (values) => {
    let tempPaymentChannelToFundSourceMappingsArray = [];
    let tempFeeToIncomeAccountMappingsArray = [];
    let tempPenaltyToIncomeAccountMappingsArray = [];

    configureFundTableSource.forEach((element, index) => {
      tempPaymentChannelToFundSourceMappingsArray.push({
        paymentTypeId: element.paymentTypeId,
        fundSourceAccountId: element.fundSourceAccountId,
      });
    });

    mapFeeTableSource.forEach((element, index) => {
      tempFeeToIncomeAccountMappingsArray.push({
        chargeId: element.chargeId,
        incomeAccountId: element.incomeAccountId,
      });
    });

    mapPenaltyTableSource.forEach((element, index) => {
      tempPenaltyToIncomeAccountMappingsArray.push({
        paymentTypeId: element.paymentTypeId,
        fundSourceAccountId: element.fundSourceAccountId,
      });
    });

    values.paymentChannelToFundSourceMappings =
      tempPaymentChannelToFundSourceMappingsArray;
    values.feeToIncomeAccountMappings = tempFeeToIncomeAccountMappingsArray;
    values.penaltyToIncomeAccountMappings =
      tempPenaltyToIncomeAccountMappingsArray;

    setFormData({
      ...formData,
      accounting: values,
      paymentChannelToFundSourceMappings:
        values.paymentChannelToFundSourceMappings,
      feeToIncomeAccountMappings: values.feeToIncomeAccountMappings,
      penaltyToIncomeAccountMappings: values.penaltyToIncomeAccountMappings,
    });
    setCurrent(current + 1);
  };

  const nextButtonClick = () => {
    form.submit();
  };

  const prevButtonClick = () => {
    setCurrent(current - 1);
  };

  function onCancel() {
    navigate("/prd0200", { replace: false });
  }

  const onSubmit = () => {
    let formValues = {
      ...formData.details,
      ...formData.currency,
      ...formData.terms,
      ...formData.settings,
      ...formData.accounting,
    };

    formValues.minPrincipal = formData?.terms?.minPrincipal;
    formValues.principal = formData?.terms?.principal;
    formValues.useBorrowerCycle = formData?.terms?.useBorrowerCycle;
    formValues.isLinkedToFloatingInterestRates =
      formData?.terms?.isLinkedToFloatingInterestRates;
    formValues.maxPrincipal = formData?.terms?.maxPrincipal;
    formValues.minNumberOfRepayments = formData?.terms?.minNumberOfRepayments;
    formValues.numberOfRepayments = formData?.terms?.numberOfRepayments;
    formValues.maxNumberOfRepayments = formData?.terms?.maxNumberOfRepayments;
    formValues.maxInterestRatePerPeriod =
      formData?.terms?.maxInterestRatePerPeriod;
    formValues.interestRatePerPeriod = formData?.terms?.interestRatePerPeriod;
    formValues.minInterestRatePerPeriod =
      formData?.terms?.minInterestRatePerPeriod;
    formValues.repaymentEvery = formData?.terms?.repaymentEvery;
    formValues.repaymentFrequencyType = formData?.terms?.repaymentFrequencyType;
    formValues.minimumDaysBetweenDisbursalAndFirstRepayment =
      formData?.terms?.minimumDaysBetweenDisbursalAndFirstRepayment;
    formValues.interestRateFrequencyType =
      formData?.terms?.interestRateFrequencyType;
    formValues.paymentChannelToFundSourceMappings =
      formData?.paymentChannelToFundSourceMappings;
    formValues.feeToIncomeAccountMappings =
      formData?.feeToIncomeAccountMappings;
    formValues.penaltyToIncomeAccountMappings =
      formData?.penaltyToIncomeAccountMappings;
    formValues.principalVariationsForBorrowerCycle =
      formData?.principalVariationsForBorrowerCycle;
    formValues.numberOfRepaymentVariationsForBorrowerCycle =
      formData?.numberOfRepaymentVariationsForBorrowerCycle;
    formValues.interestRateVariationsForBorrowerCycle =
      formData?.interestRateVariationsForBorrowerCycle;
    formValues.charges = formData.charges;
    formValues.accountingRule = radioChecked;

    delete formValues.specificIncomeAccountMapping;
    delete formValues.incomeAccountId;
    delete formValues.penaltySpecificIncomeAccounts;
    delete formValues.configureFundOptions;
    delete formValues.penaltySpecificIncomeAccount;

    const body = {
      ...formValues,
      locale: "en",
      dateFormat: "dd MMMM yyyy",
      method: "POST",
      session,
    };

    setIsLoading(true);
    BOM.FetchReqAction(body, definedApi.NewLoanProduct, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.errors[0].defaultUserMessage);
        setIsLoading(false);
      } else {
        BOM.AlertMsg(cnt.SUCCESS, appLabel.newLoanProductMsg);
        navigate("/prd0200");
        //STOP LOAD
        setIsLoading(false);
      }
    });
  };

  const forms = [
    <DetailsForm
      onFinish={onFinishDetailsForm}
      current={current}
      setCurrent={setCurrent}
      initialValues={formData.details}
      form={form}
      fundsData={fundsData}
      handleIncludeInBorrowerCycle={handleIncludeInBorrowerCycle}
      includeInBorrowerCycle={includeInBorrowerCycle}
    />,
    <CurrencyForm
      onFinish={onFinishCurrencyForm}
      current={current}
      setCurrent={setCurrent}
      initialValues={formData.currency}
      form={form}
      currencyData={currencyData}
      onChange={onChangeCurrency}
    />,
    <TermsForm
      onFinish={onFinishTermsForm}
      current={current}
      setCurrent={setCurrent}
      initialValues={formData.terms}
      form={form}
      repaymentFrequencyTypeOptions={repaymentFrequencyTypeOptions}
      interestRateFrequencyTypeOptions={interestRateFrequencyTypeOptions}
      handleUseBorrowerCycle={handleUseBorrowerCycle}
      useBorrowerCycle={useBorrowerCycle}
      handleIsLinkedToFloatingInterestRates={
        handleIsLinkedToFloatingInterestRates
      }
      isLinkedToFloatingInterestRates={isLinkedToFloatingInterestRates}
      valueConditionTypeOptions={valueConditionTypeOptions}
      floatingRateOptions={floatingRateOptions}
      principalByLoanCycleSource={principalByLoanCycleSource}
      setPrincipalByLoanCycleSource={setPrincipalByLoanCycleSource}
      repaymentsByLoanCycleSource={repaymentsByLoanCycleSource}
      setRepaymentsByLoanCycleSource={setRepaymentsByLoanCycleSource}
      setInterestRateByLoanCycleSource={setInterestRateByLoanCycleSource}
      interestRateByLoanCycleSource={interestRateByLoanCycleSource}
    />,
    <SettingsForm
      onFinish={onFinishSettingsForm}
      current={current}
      setCurrent={setCurrent}
      initialValues={formData.settings}
      form={form}
      variableInstallmentsChecked={variableInstallmentsChecked}
      recalculateInterestCheck={recalculateInterestCheck}
      multipleDisbursalsCheck={multipleDisbursalsCheck}
      guaranteeRequirementsCheck={guaranteeRequirementsCheck}
      amortizationData={amortizationData}
      interestTypeData={interestTypeData}
      interestCalculationPeriodTypeData={interestCalculationPeriodTypeData}
      daysInYearData={daysInYearData}
      daysInMonthData={daysInMonthData}
      preClosureInterestCalculationStrategy={
        preClosureInterestCalculationStrategy
      }
      rescheduleStrategyType={rescheduleStrategyType}
      interestRecalculationCompoundingType={
        interestRecalculationCompoundingType
      }
      recalculationRestFrequencyType={recalculationRestFrequencyType}
      handleIsEqualAmortization={handleIsEqualAmortization}
      isEqualAmortization={isEqualAmortization}
      handleAllowPartialPeriodInterestCalcualtion={
        handleAllowPartialPeriodInterestCalcualtion
      }
      allowPartialPeriodInterestCalcualtion={
        allowPartialPeriodInterestCalcualtion
      }
      handleCanDefineInstallmentAmount={handleCanDefineInstallmentAmount}
      canDefineInstallmentAmount={canDefineInstallmentAmount}
      handleAccountMovesOutOfNPAOnlyOnArrearsCompletion={
        handleAccountMovesOutOfNPAOnlyOnArrearsCompletion
      }
      accountMovesOutOfNPAOnlyOnArrearsCompletion={
        accountMovesOutOfNPAOnlyOnArrearsCompletion
      }
      handleAllowVariableInstallments={handleAllowVariableInstallments}
      allowVariableInstallments={allowVariableInstallments}
      handleCanUseForTopup={handleCanUseForTopup}
      canUseForTopup={canUseForTopup}
      handleIsInterestRecalculationEnabled={
        handleIsInterestRecalculationEnabled
      }
      isInterestRecalculationEnabled={isInterestRecalculationEnabled}
      handleHoldGuaranteeFunds={handleHoldGuaranteeFunds}
      holdGuaranteeFunds={holdGuaranteeFunds}
      handleMultiDisburseLoan={handleMultiDisburseLoan}
      multiDisburseLoan={multiDisburseLoan}
      handleIsArrearsBasedOnOriginalSchedule={
        handleIsArrearsBasedOnOriginalSchedule
      }
      isArrearsBasedOnOriginalSchedule={isArrearsBasedOnOriginalSchedule}
      interestRecalculationFrequencyTypeOptions={
        interestRecalculationFrequencyTypeOptions
      }
      interestRecalculationDayOfWeekTypeOptions={
        interestRecalculationDayOfWeekTypeOptions
      }
      interestRecalculationNthDayTypeOptions={
        interestRecalculationNthDayTypeOptions
      }
      handleAllowAttributeConfiguration={handleAllowAttributeConfiguration}
      allowAttributeConfiguration={allowAttributeConfiguration}
      handleGraceOnArrearsAging={handleGraceOnArrearsAging}
      handleInterestCalcPeriod={handleInterestCalcPeriod}
      handleRepaymentFrequency={handleRepaymentFrequency}
      handleGraceOnPrincipalAndInterest={handleGraceOnPrincipalAndInterest}
      handleInterestMethod={handleInterestMethod}
      handleTransactionProcessingStrategy={handleTransactionProcessingStrategy}
      handleArrearsTolerance={handleArrearsTolerance}
      handleAmortization={handleAmortization}
      amortization={amortization}
      transactionProcessingStrategy={transactionProcessingStrategy}
      arrearsTolerance={arrearsTolerance}
      graceOnPrincipalAndInterest={graceOnPrincipalAndInterest}
      interestMethod={interestMethod}
      interestCalcPeriod={interestCalcPeriod}
      repaymentFrequency={repaymentFrequency}
      graceOnArrearsAging={graceOnArrearsAging}
      transactionProcessingStrategyOptions={
        transactionProcessingStrategyOptions
      }
    />,
    <ChargesForm
      onFinish={onFinishChargesForm}
      current={current}
      userData={userData}
      setCurrent={setCurrent}
      initialValues={formData.charges}
      form={form}
      isLoading={isLoading}
      setIsLoading={setIsLoading}
      chargesOptions={chargeBasedOnCurrencyList}
      penaltyOptions={penaltyBasedOnCurrencyList}
      setChargeTableSource={setChargeTableSource}
      chargeTableSource={chargeTableSource}
      penaltyTableSource={penaltyTableSource}
      setPenaltyTableSource={setPenaltyTableSource}
    />,
    <AccountingForm
      onFinish={onFinishAccountingForm}
      current={current}
      setCurrent={setCurrent}
      initialValues={formData.accounting}
      form={form}
      accountingRuleOptions={accountingRuleOptions}
      assetAccountOptions={assetAccountOptions}
      incomeAccountOptions={incomeAccountOptions}
      expenseAccountOptions={expenseAccountOptions}
      liabilityAccountOptions={liabilityAccountOptions}
      paymentTypeOptions={paymentTypeOptions}
      charges={charges}
      setRadioChecked={setRadioChecked}
      configureFundTableSource={configureFundTableSource}
      setConfigureFundTableSource={setConfigureFundTableSource}
      mapFeeTableSource={mapFeeTableSource}
      setMapFeeTableSource={setMapFeeTableSource}
      mapPenaltyTableSource={mapPenaltyTableSource}
      setMapPenaltyTableSource={setMapPenaltyTableSource}
      radioChecked={radioChecked}
      userData={userData}
      chargesOptions={chargesOptions}
      penaltyOptions={penaltyOptions}
    />,
    <Preview
      formData={formData}
      configureFundTableSource={configureFundTableSource}
      mapFeeTableSource={mapFeeTableSource}
      loanProductDetails={loanProductDetails}
    />,
  ];

  const isLastStep = current === forms.length - 1;

  return (
    <>
      <Row style={{ marginBottom: 25 }}>
        <Col span={24}>
          {/*Interractive Section */}
          <Row style={{ justifyContent: "space-between" }}>
            {/* Navigation section */}
            <Card style={styles.cardSteps}>
              <Steps
                current={current}
                onChange={onChange}
                direction="vertical"
                style={{ height: "600px" }}
                items={[
                  {
                    title: <Text strong>Details</Text>,
                  },
                  {
                    title: <Text strong>Currency</Text>,
                  },
                  {
                    title: <Text strong>Terms</Text>,
                  },
                  {
                    title: <Text strong>Settings</Text>,
                  },
                  {
                    title: <Text strong>Charges</Text>,
                  },
                  {
                    title: <Text strong>Accounting</Text>,
                  },
                  {
                    title: <Text strong>Preview</Text>,
                  },
                ]}
              />
            </Card>
            {/* Form Section */}
            <Card style={styles.cardStepDisplay}>
              <div>{forms[current]}</div>
            </Card>
          </Row>
        </Col>
      </Row>

      {/* Submitt section */}
      <Card
        style={{
          marginBottom: 25,
          boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
          borderRadius: 20,
        }}
      >
        <Flex
          justify="space-between"
          style={{ paddingLeft: "10px", paddingRight: "40px" }}
        >
          {current === 0 && (
            <Button
              style={{
                width: "10%",
                backgroundColor: "white",
                boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                borderRadius: 20,
              }}
              colortext="black"
              onClick={onCancel}
            >
              Cancel
            </Button>
          )}
          {current > 0 && (
            <Button
              style={{
                width: "10%",
                backgroundColor: "#92428B",
                color: "white",
                boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                borderRadius: 20,
              }}
              onClick={prevButtonClick}
            >
              Prev
            </Button>
          )}
          {!isLastStep && (
            <Button
              style={{
                width: "10%",
                backgroundColor: "#92428B",
                color: "white",
                boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                borderRadius: 20,
              }}
              onClick={nextButtonClick}
            >
              Next
            </Button>
          )}
          {BOM.HasPermission("CREATE_LOANPRODUCT") && isLastStep && (
            <Button
              style={{
                width: "10%",
                backgroundColor: "white",
                boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                borderRadius: 20,
              }}
              onClick={onSubmit}
            >
              Submit
            </Button>
          )}
        </Flex>
      </Card>
    </>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(LoanProductForm);
